import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@constants/routes';
import FinalFeature from '@features/final';
import { useFormStore } from '@store/use-form-store';

function ElearningWpOnSiteFinalPage() {
  const navigate = useNavigate();
  const { resetProcess } = useFormStore();

  const handleReset = () => {
    resetProcess();
    navigate(ROUTES.EWOS_MVE);
  };

  return <FinalFeature isElearningWpOnsite={true} onReset={handleReset} />;
}

export default ElearningWpOnSiteFinalPage;
